import { queryAllowances } from "@/services/allowances.service";

const Model = {
  namespace: 'featuresAndtramitsAndnewTramit',
  state: {
    allowances: [],
    isFetchingAllowances: false,

    current: 'info',
    step: {
      payAccount: 'ant-design@alipay.com',
      receiverAccount: 'test@example.com',
      receiverName: 'Alex',
      amount: '500',
    },
  },
  effects: {
    *getAllowances({ payload }, { call, put }) {
      yield put({
        type: 'setLoadingAllowances',
        payload: true,
      });

      try {
        const response = yield call(queryAllowances, payload);
        yield put({
          type: 'saveAllowances',
          payload: response,
        });
      } catch (error) {
        yield put({
          type: 'setLoadingAllowances',
          payload: false,
        });
      }
    },
  },
  reducers: {
    saveAllowances(state, { payload }) {
      return { ...state, allowances: payload.results, isFetchingAllowances: false };
    },

    setLoadingAllowances(state, { payload }) {
      return { ...state, isFetchingAllowances: payload };
    },

    saveCurrentStep(state, { payload }) {
      return { ...state, current: payload };
    },

    saveStepFormData(state, { payload }) {
      return { ...state, step: { ...state.step, ...payload } };
    },
  },
};
export default Model;
